define(function (require, exports) {
    'use strict';
    
    var moment = require('moment');

    /**
     * @ngInject
     */
    function metDatesFormatter($filter) {

        return {
            /**
             * Filter for converting Date to ISO date substring
             * (Date)date<"2016-03-24T15:51:44.633Z"> -> (String)"2016-03-24"
             */
            metDateToISO: function(date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            },
            /**
             * Filter for converting ISO timestamp "2016-03-24T15:51:44.633Z" to Date("2016-03-24")
             */
            metDateFromISO: function(ISOdateTimestamp) {
                return new Date(moment(ISOdateTimestamp.substring(0, 10)));
            },
            /**
             * Filter for converting calendar Date format "24 Aug 2016" to Date("2016-03-24")
             */
            calendarDateFromISO: function(ISOdateTimestamp) {
                return new Date(moment(ISOdateTimestamp.substring(0, 11)));
            }
        };
    }

    /**
     * Exports
     */
    exports.metDatesFormatter = metDatesFormatter;
});



// WEBPACK FOOTER //
// ./scripts/services/metDatesFormatter.js